export default "__VITE_PUBLIC_ASSET__c1f11dc3__"